import IDream from "motw_core/Entity/IDream";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import { State } from "source/app/services/UI/State/State";
import { IDreamEditorState } from "../DreamEditor";
import { hashTagsService } from "motw_core/Services/HashTagsService";

export const GetEditedDream = (): IDream => {
    const editedDream = State.ReadClass<IDreamEditorState>(
        ESharedComponent.DreamEditor
    ).state.dream;

    MoveAllHashTagsToEnd(editedDream);
    return editedDream;
};

function MoveAllHashTagsToEnd(originalDream: IDream) {
    const hashTagsInDream =
        hashTagsService.GetAllHashTagsInDream(originalDream);

    hashTagsInDream.forEach((hashTag) => {
        const withoutHashTag = hashTagsService.GetStringWithoutHashTag(
            originalDream.name,
            hashTag
        );

        const withHashTagAtEnd = hashTagsService.GetStringWithHashTag(
            withoutHashTag,
            hashTag
        );

        originalDream.name = withHashTagAtEnd;
    });
}
